// 开发环境
export default {
  //cookie域名
  DOMAIN_NAME: '.jlwtest.com',
  // DOMAIN_NAME_v3: 'm.jlwtest.com',

  //二版接口
  WS_BASE_URL: 'ws://118.25.139.57:5010',
  BASE_URL: 'http://118.25.139.57:5020/',

  //API根域名
  API_URL: 'https://api.jlwgroups.com/',

  //三版接口与文件上传
  BASE_URL_V3: 'http://m.jlwgroups.com/api/',
  UPLOAD_URL: 'https://api.jlwgroups.com/api/harbor/tencent/cloud/cos/',

  //三版前端项目地址
  // LOGIN_URL: 'http://localhost:3035',
  // REDIRECT_URL: 'http://localhost:3006',
  // BACKSTAGE_URL: 'http://localhost:3008',
  MOBILE_V3: 'http://m.jlwtest.com',
  LOGIN_URL: 'http://www.jlwtest.com',
  REDIRECT_URL: 'http://console.jlwtest.com',
  BACKSTAGE_URL: 'http://admin.jlwtest.com',
  EXHIBITION_URL: 'http://www.exhibition.jlwtest.com',


  // 二版前台地址（二版与三版前台部分可能会分离）
  RECEPTION_URL: 'http://mall.jlwtest.com',

  //对象存储参数
  BUCKET: 'test-jlwgroups-1257889624',
  REGION: 'ap-shanghai',
  UPLOAD_DOMAIN: 'https://file-cos.jlwgroups.com/',
  ACCESSPATH: 'upload/',

  //契约锁
  qiyuesuo: "https://passport.qiyuesuo.cn/login/pc",
  qiyuesuoOfficialWebsite: "https://www.qiyuesuo.cn/",

  //微信appid
  weChatAppId: 'wx94a2cbfd533cccf4',

  isDebug: true
}



// WEBPACK FOOTER //
// ./src/config/local.config.js